class ExpendableBlock {
  /**
   * @param {HTMLElement} element - the accordion element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        button: ".js-ExpendableBlock-button",
        content: ".js-ExpendableBlock-content",
      },
    };

    this.button = this.element.querySelector(this.config.selectors.button);
    this.content = this.element.querySelector(this.config.selectors.content);

    this.button.addEventListener("click", () => {
      this.button.setAttribute("hidden", "true");
      this.content.setAttribute("aria-expanded", "true");
    });
  }
}

export default ExpendableBlock;
